// import React from "react";
// import s from "./InCountry.module.scss";
// import { useLocation, useParams } from "react-router-dom";
// import i18n from "../../i18n/i18n";
// import { useTranslation } from "react-i18next";

// const InCountry = () => {
//   const location = useLocation();
//     const { t } = useTranslation();

//   return (
//     <div className={s.content}>
//       <div className={s.text}>
//         <div className={s.title}>
//           {location.pathname.includes("/russia")
//             ? "Я в России/"
//             : location.pathname.includes("/kazakhstan")
//               ? "Я в Казахстане/"
//               : "Я в другой стране/"}
//         </div>
//         <div className={s.subtitle}>
//           Собираюсь <br />{" "}
//           {location.pathname.includes("/russia")
//             ? "в Россию"
//             : location.pathname.includes("/kazakhstan")
//               ? "в Казахстан"
//               : "в другую страну"}
//         </div>
//       </div>
//       <div className={s.photo}>
//         <img
//           src={
//             location.pathname.includes("/russia")
//               ? "/images/Russia.svg"
//               : location.pathname.includes("/kazakhstan")
//                 ? "/images/Kazakhstan.svg"
//                 : "/images/Other countries.svg"
//           }
//           alt="In Country Photo 1"
//           className={s.img}
//         />
//       </div>
//     </div>
//   );
// };

// export default InCountry;

import React from "react";
import s from "./InCountry.module.scss";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const InCountry = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className={s.content}>
      <div className={s.text}>
        <div className={s.title}>
          {location.pathname.includes("/russia")
            ? `${t("Законодательство России")}`
            : location.pathname.includes("/kazakhstan")
              ? `${t("Законодательство Казахстана")}`
              : `${t("Законодательство других стран")}`}
        </div>

        <div className={s.subtitle}>
          {t("в сфере миграции и здоровья")}
        </div>
      </div>

      <div className={s.photo}>
        <img
          src={
            location.pathname.includes("/russia")
              ? "/images/Russia.svg"
              : location.pathname.includes("/kazakhstan")
                ? "/images/Kazakhstan.svg"
                : "/images/Other countries.svg"
          }
          alt={t("Страна пребывания")}
          className={s.img}
        />
      </div>
    </div>
  );
};

export default InCountry;
